import { RootState } from '../store'

export const platformDetectionSelector = (state: RootState): boolean =>
  state?.platformDetection?.isMobileApp || false
